import { profileUrl } from './urls';

export const personProfileLink = (person, isSteward = true) => {
  const personId = (person && person._id) || person;
  return `${profileUrl}/${personId}${isSteward ? `?isSteward=true` : ``}`;
};
